module.exports = __webpack_public_path__ + "img/loyallyst.df596a2c.png";